<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">{{ type === 'new' ? 'Организация (создание)' : 'ООО «КлеверСпорт» (организация)' }}</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Нормативы /</span> {{ type === 'new' ? 'Организация (создание)' : 'ООО «КлеверСпорт» (организация)' }}</div>
                </div>
                <div v-if="organizationTab === 0">
                  <v-btn
                      color="#629F33"
                      class="button__success"
                      v-if="!organization_id"
                      @click="saveOrganization()"
                  >
                    Сохранить
                  </v-btn>
                  <div v-else>
                    <v-btn
                        color="#629F33"
                        class="button__success"
                        @click="saveOrganization(organization_id)"
                    >
                      Изменить
                    </v-btn>
                    <v-btn v-if="organization.flag_deletion" class="button" style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;" @click="deleteOrganization(false)">
                      Снять пометку на удаление
                    </v-btn>
                    <v-btn v-else class="button__danger" style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;" @click="deleteOrganization(true)">
                      Удалить
                    </v-btn>
                  </div>
                  
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="organizationTab"
                      centered
                      height="40"
                  >
                    <v-tab v-for="item in organizationType" :key="item.id" class="ml-4">
                      {{ item.name }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
              </v-col>

              <v-col cols="12" v-if="organization && organization.flag_deletion" >
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray" style="background:#f44336; opacity:0.4; display:flex; align-items:center; justify-content:center; color:white;">
                  <div>Удалено</div>
                </v-sheet>
              </v-col>

              <v-col>
                <v-tabs-items v-model="organizationTab">

                  <v-tab-item>
                    <v-row>
                      <v-col style="padding: 0 !important;" md="6">
                        <v-col>
                          <v-sheet rounded="lg" class="card">
                            <v-col>
                              <label class="card-title">Организация</label>
                              <v-text-field
                                  v-model="organization.fullname"
                                  label="Полное наименование"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                  v-model="organization.org_name"
                                  label="Наименование"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col>
                              <v-btn-toggle
                                  v-model="organization.org_type_value"
                                  mandatory
                                  class="rounded-lg"
                              >
                                <v-btn style="padding: 12px 20px !important; background-color: #fff !important;" @click="organization.org_type = 'ЮрЛицо'">
                                  Юридическое лицо
                                </v-btn>
                                <v-btn style="padding: 12px 20px !important; background-color: #fff !important;" @click="organization.org_type = 'ФизЛицо'">
                                  Физическое лицо
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>
                          </v-sheet>
                        </v-col>
                
                        <v-col>
                          <!-- <v-sheet rounded="lg" class="card">
                            <v-col>
                              <label class="card-title">Данные об ответственных лицах</label>
                              <v-row>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Руководитель 1"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select>
                                </v-col>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Руководитель 2"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select>
                                </v-col>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Главный бухгалтер 1"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;"
                                  ></v-select>
                                </v-col>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Главный бухгалтер 2"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;"
                                  ></v-select>
                                </v-col>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Кассир 1"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;"
                                  ></v-select>
                                </v-col>
                                <v-col md="6">
                                  <v-select
                                      class="rounded-lg"
                                      v-model="organization.type"
                                      :items="[]"
                                      item-value="type_id"
                                      item-text="type_name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Кассир 2"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;"
                                  ></v-select>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-sheet> -->
                        </v-col>
                  
                      </v-col>

                      <v-col style="padding: 0 !important;" md="6">

                        <v-col>
                      
                          <v-sheet rounded="lg" class="card">

                              <label class="card-title">Коды</label>
                              <v-row>
                                  <v-col md="6">
                                    <v-text-field
                                        v-if="organization.org_type === 'ЮрЛицо'"
                                        v-model="organization.inn"
                                        label="ИНН"
                                        outlined
                                        dense
                                        style="height: 48px;margin-top: 10px"
                                        class="rounded-lg"
                                        :rules="[rules.onlyDigits, rules.minLength, rules.maxLength]"
                                    ></v-text-field>
                                    <v-text-field
                                        v-else
                                        v-model="organization.inn"
                                        label="ИНН"
                                        outlined
                                        dense
                                        style="height: 48px;margin-top: 10px"
                                        class="rounded-lg"
                                        :rules="[rules_fiz.onlyDigits, rules_fiz.minLength, rules_fiz.maxLength]"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col md="6">
                                    <v-text-field
                                        v-model="organization.okpo"
                                        label="ОКПО"
                                        outlined
                                        dense
                                        style="height: 48px;margin-top: 10px"
                                        class="rounded-lg"
                                    ></v-text-field>
                                  </v-col>

                                </v-row>
                                <v-row>
                                  <v-col md="6">
                                    <v-text-field
                                        v-model="organization.kpp"
                                        label="КПП"
                                        outlined
                                        dense
                                        style="height: 48px;margin-top: 10px"
                                        class="rounded-lg"
                                        :rules="[rules_kpp.onlyDigits, rules_kpp.minLength, rules_kpp.maxLength]"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col md="6">
                                    <v-text-field
                                        v-model="organization.ogrn"
                                        label="ОГРН"
                                        outlined
                                        dense
                                        style="height: 48px;"
                                        class="rounded-lg"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col md="12">
                                    <label>Банковские счета</label>
                                    <v-select
                                        class="rounded-lg"
                                        v-model="organization.bank_account_id"
                                        :items="bank_account_list"
                                        item-value="id"
                                        item-text="name"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        label="счёт"
                                        append-icon="mdi-chevron-down"
                                        outlined
                                        dense
                                        required
                                        style="height: 48px;margin-top: 10px"
                                        hide-details
                                    ></v-select>
                                  </v-col>
                                </v-row>
                          </v-sheet>

                        </v-col>



                      </v-col>

                    </v-row>


                    <v-row>
                      <v-col style="" md="12">
                    <v-sheet>
                      <v-col style="" md="12">
                        <div style="display:flex; align-items:center; justify-content:space-between;">
                          <div>
                            <label class="card-title">Система налогообложения</label>
                          </div>

                            <v-btn
                                class="button__lighten"
                                @click="addService()"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Добавить
                            </v-btn>
                        </div>

                        <v-row style="margin-top: 10px;" v-for="service_item in organization.sno_array" :key="service_item.idd">

                          <v-col md="2" style="padding-top:20px;">
                            <template>
                              <VueDatePicker
                                  no-title
                                  no-header
                                  color="#629f34"
                                  v-model="service_item.date"
                                  format="DD.MM.YYYY"
                                  placeholder="Дата"
                                  label="Дата"
                              >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker custom__datepicker44"
                                    ref="activator"
                                    type="button"
                                >
                                  <div>
                                    <span v-if="date">{{ date }}</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                              </VueDatePicker>
                            </template>
                              
                          </v-col>
              
                          <v-col md="3">
                            <!-- <label class="card-title">Предмет налогообложения</label> -->
                            <v-select
                                v-model="service_item.tax_subject"
                                class="rounded-lg"
                                :items="[{id:'Авансы',name:'Авансы'},{id:'Товары',name:'Товары'},{id:'Услуги',name:'Услуги'}]" item-title="name" item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Предмет налогообложения"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 10px;"
                            ></v-select>
                          </v-col>
                          <v-col md="3">
                            <!-- <label class="card-title">Система налогообложения</label> -->
                            <v-select
                                v-model="service_item.sno"
                                class="rounded-lg"
                                :items="[{id:'ОСН',name:'Общая'},{id:'УСНДоход',name:'Упрощенная доход'}]" item-title="name" item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Система налогообложения"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 10px;"
                            ></v-select>

                          </v-col>
              
                          <v-col md="3">
                            <!-- <label class="card-title">Ставка НДС</label> -->
                            <v-select
                                v-model="service_item.nds_id"
                                class="rounded-lg"
                                :items="nds_list" item-title="name" item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Ставка НДС"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 10px;"
                            ></v-select>
                          </v-col>

                          <v-col md="1" style="padding-top:20px;">
                            <v-btn icon @click="removeService(service_item.id)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-col>

                      </v-row>
                      </v-col>
                    </v-sheet>
                      </v-col>

                    </v-row>



                    <v-row>
                    
                      <v-col style="" md="12">

                        <v-sheet>
                          <v-col style="" md="12">
                        <label class="card-title">Данные об ответственных лицах</label>
                              <v-row style="padding:20px 0px;">
                                <v-col md="6">
                                  <v-autocomplete
                                    v-if="specialist_list && specialist_list.length > 0"
                                        v-model="organization.leader_details.employee_id"
                                        :items="specialist_list"
                                        label="Руководитель"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>
                                <v-col md="6">
                                  <v-autocomplete
                                    v-if="position_list && position_list.length > 0"
                                        v-model="organization.leader_details.position_id"
                                        :items="position_list"
                                        label="Должность"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>
                                <v-col md="6">
                                  
                                  <v-autocomplete
                                    v-if="specialist_list && specialist_list.length > 0"
                                        v-model="organization.accountant_details.employee_id"
                                        :items="specialist_list"
                                        label="Главный бухгалтер"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>
                                <v-col md="6">
                                  <v-autocomplete
                                    v-if="position_list && position_list.length > 0"
                                        v-model="organization.accountant_details.position_id"
                                        :items="position_list"
                                        label="Должность"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>

                                  <v-col md="6">
                                  <v-autocomplete
                                    v-if="specialist_list && specialist_list.length > 0"
                                        v-model="organization.cashier_details.employee_id"
                                        :items="specialist_list"
                                        label="Кассир"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>
                                <v-col md="6">
                                  <v-autocomplete
                                    v-if="position_list && position_list.length > 0"
                                        v-model="organization.cashier_details.position_id"
                                        :items="position_list"
                                        label="Должность"
                                        item-text="name"
                                        item-value="id"
                                        :filter="customFilter"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        clearable
                                        class="rounded-lg"
                                        style="height: 48px;"
                                        required
                                        outlined
                                      >
                                        <!-- Кастомный шаблон для отображения с категорией -->
                                        <template v-slot:item="data">
                                          <template v-if="data.item">
                                            <div class="d-flex flex-column">
                                              <small class="grey--text">{{ data.item.name }}</small>
                                            </div>
                                          </template>
                                        </template>
                                      </v-autocomplete>
                                </v-col>

                              </v-row>

                            </v-col>
                        </v-sheet>

                      </v-col>
                    </v-row>


                    <v-row>
                      <v-col style="" md="12">
                          <v-sheet>
                            <v-col style="" md="12">
                              <div style="display:flex; align-items:center; justify-content:space-between;">
                                <div>
                                  <label class="card-title">Контакты</label>
                                </div>

                                  <v-btn
                                      class="button__lighten"
                                      @click="addContact()"
                                  >
                                    <v-icon small class="mr-2">mdi-plus</v-icon>
                                    Добавить
                                  </v-btn>
                              </div>
                            </v-col>

                            <v-col md="12">
                                <div v-if="!organization.contact_array || organization.contact_array.length === 0">
                                  Нет контактов
                                </div>

                                <div v-for="cont in organization.contact_array" :key="cont.id">

                                  <label class="card-title" >
                                    {{ cont.type }}
                                  </label>
                                  <v-text-field
                                            v-if="cont.type === 'Телефон'"
                                            v-model="cont.phonenumber"
                                            placeholder="Введите текст"
                                            outlined
                                            clearable
                                            v-mask="'+7 (###) ###-##-###'"
                                  ></v-text-field>
                                  <v-text-field
                                            v-if="cont.type === 'ЮридическийАдрес'"
                                            v-model="cont.adress"
                                            placeholder="Введите текст"
                                            outlined
                                            clearable
                                  ></v-text-field>
                                  <v-text-field
                                            v-if="cont.type === 'ФактическийАдрес'"
                                            v-model="cont.adress"
                                            placeholder="Введите текст"
                                            outlined
                                            clearable
                                  ></v-text-field>
                                  <v-text-field
                                            v-if="cont.type === 'ПочтовыйАдрес'"
                                            v-model="cont.adress"
                                            placeholder="Введите текст"
                                            outlined
                                            clearable
                                  ></v-text-field>

                                </div>

                            </v-col>

                          </v-sheet>
                        </v-col>
                    </v-row>

                  </v-tab-item>

<!--------------------------------------------------------------------------------------------------------------------->

                  <v-tab-item>
                    <v-sheet class="rounded-t-lg">
                      <v-card-title
                          class="d-flex align-center"
                      >
                        <v-btn
                            class="button__lighten"
                            @click="dialogBill = true"
                        >
                          <v-icon small class="mr-2">mdi-plus</v-icon>
                          Создать
                        </v-btn>
                        <v-btn
                                class="button__danger ml-3"
                                v-if="selectedLine && selectedLine.id"
                                @click="deleteBank(selectedLine)"
                                style="margin: 0px 10px !important;"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              <span v-if="selectedLine.deletion">Снять пометку на удаление</span>
                              <span v-else>Удалить</span>
                            </v-btn>

                            <v-btn
                                class="button__lighten ml-3"
                                v-else
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>
                      </v-card-title>
                    </v-sheet>
                    <v-data-table
                        :headers="headersBills"
                        :items="bank_account_list ? bank_account_list : []"
                        item-key="id"
                        no-data-text="Ничего не найдено"
                        :hide-default-footer="true"
                              disable-pagination
                        class="elevation-1"
                    >
                        <template v-slot:item="{ item }">
                                      <tr
                                        @click="setNomenOrg(item)"
                                        @dblclick="new_bank = item, new_bank.bank_id = item.bank.name, new_bank.org_id = item.owner.id, new_bank.currency = 'RUR', dialogBill = true"
                                        :class="[
                                          { 
                                            'active-row': selectedLine && selectedLine.id === item.id 
                                          }
                                        ]"
                                      >
                                        <td>
                                          {{ item.name }}
                                          <span v-if="item.deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                    
                                      </tr>
                                    </template>
                    </v-data-table>
                  </v-tab-item>


                </v-tabs-items>
              </v-col>
            </v-row>


            <v-row justify="center">
              <v-dialog
                  v-model="dialogBill"
                  persistent
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Банковский счет (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogBill = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="form">
                        <v-row>
                          <v-col md="6">
                            <label class="card-title">Реквизиты банка</label>
                            <v-text-field
                                v-model="new_bank.number"
                                label="Номер счета"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                                :rules="[rules_bank.onlyDigits, rules_bank.minLength, rules_bank.maxLength]"
                            ></v-text-field>
                            <v-text-field
                                v-model="new_bank.bik"
                                label="БИК"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <!-- <v-text-field
                                v-model="new_bank.bank_id"
                                label="Банк"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <v-text-field
                                v-model="new_bank.kor_number"
                                label="Корр. счет"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field> -->
                            <v-text-field
                                v-model="new_bank.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <label class="card-title">Дополнительно</label>
                            <v-text-field
                                v-model="new_bank.show"
                                label="Представление"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <!-- <v-text-field
                                v-model="new_bank.org_id"
                                label="Владелец счета"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field> -->

                            
                             <v-select
                                  v-model="new_bank.org_id"
                                  :items="org_list ? org_list : []"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  label="Владелец счета"
                                  color="#629F33"
                                  background-color="#fff"
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>

                              <v-select
                                  v-model="new_bank.currency"
                                  :items="[{id:'RUR',name:'РУБ'}]"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  label="Валюта"
                                  color="#629F33"
                                  background-color="#fff"
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>

                            <!-- <v-text-field
                                v-model="new_bank.currency"
                                label="Валюта"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field> -->
                          </v-col>
                          <v-col class="d-flex justify-end">

                            <div
                                v-if="new_bank.id"
                                class="button button__success"
                                style="cursor:pointer;"
                                @click="updateBank"
                            >
                              Изменить
                            </div>

                            <div
                                v-else
                                class="button button__success"
                                style="cursor:pointer;"
                                @click="saveBank"
                            >
                              Сохранить
                            </div>

                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {billActionTypes} from "@/store/modules/bill";
import {organizationActionTypes} from "@/store/modules/organization";
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import {lessonActionTypes} from "@/store/modules/lesson";

export default {
  name: "Organization",
  props: ['type','organization_id'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  data() {
    return {
      organization: {
        org_name: null,
        fullname: null,
        org_type: null,
        org_type_value:0,
        inn:null,
        okpo:null,
        kpp:null,
        ogrn:null,
        bank_account_id:null,
        sno_array:
        [
          {
            date:null,
            sno:null,
            tax_subject:null,
            tax_group_id:null,
            nds_id:null
          }
        ],
        leader_details:{
          employee_id:null,
          position_id:null
        },
        accountant_details:{
          employee_id:null,
          position_id:null
        },
        cashier_details:{
          employee_id:null,
          position_id:null
        },
        contact_array:[]
      },
      contact_def:{
            type:null,
            phonenumber:null,
            email:null,
            area:null,
            street:null,
            houseNumber:null,
            code:null,
            apartment:null,
            structure:null,
            entrance:null,
            type_name:null
          },
      contact_def_array:[
        {
          id:"Телефон",
          name:"Телефон"
        },
        {
          id:"Email",
          name:"Email"
        },
        {
          id:"ЮридическийАдрес",
          name:"Юридический Адрес"
        },
        {
          id:"ФактическийАдрес",
          name:"Фактический Адрес"
        },
        {
          id:"ПочтовыйАдрес",
          name:"Почтовый Адрес"
        }
      ],
      nds_list:[
      {
            "id": "e69b3fcb-5ce3-11ed-8122-6cae8b562436",
            "name": 0
        },
        {
            "id": "e69b4094-5ce3-11ed-8122-6cae8b562436",
            "name": 20
        },
        {
            "id": "d9305017-f4f2-11ef-b3a9-6eae8b56243b",
            "name": 20
        },
        {
            "id": "8f92eb7e-8194-11f0-b3a9-6eae8b56243b",
            "name": 5
        }
      ],
      organizationTab: 0,
      organizationType: [
        {id: 0, name: 'Основное'},
        {id: 1, name: 'Банковские счета'}
      ],
      headersBills: [
        {text: 'Представлением', align: 'start', value: 'name'},
      ],
      dialogBill: false,
      bank_account_list:[],
      position_list:[],
      specialist_list:[],
      rules: {
        onlyDigits: v => /^\d*$/.test(v) || 'Только цифры',
        minLength: v => v.length >= 10 || 'Минимум 12 цифр',
        maxLength: v => v.length <= 12 || 'Максимум 12 цифр'
      },
      rules_fiz: {
        onlyDigits: v => /^\d*$/.test(v) || 'Только цифры',
        minLength: v => v.length >= 10 || 'Минимум 10 цифр',
        maxLength: v => v.length <= 12 || 'Максимум 10 цифр'
      },
      rules_kpp: {
        onlyDigits: v => /^\d*$/.test(v) || 'Только цифры',
        minLength: v => v.length >= 10 || 'Минимум 9 цифр',
        maxLength: v => v.length <= 12 || 'Максимум 9 цифр'
      },
      rules_bank:{
        onlyDigits: v => /^\d*$/.test(v) || 'Только цифры',
        minLength: v => v.length >= 20 || 'Минимум 20 цифр',
        maxLength: v => v.length <= 20 || 'Максимум 20 цифр'
      },
      org_list:[],
      new_bank:{
        org_id:null,
        number:null,
        bik:null,
        currency:null,
        name:null
      },
      selectedLine:null
    }
  },
  mounted() {

    if(this.organization_id){
      this.$store.dispatch(organizationActionTypes.organizationInfo,
        this.organization_id
      ).then((response) => {
        if (response.success) {
            this.organization = response.organization
              if(this.organization.sno_array && this.organization.sno_array.length > 0) {
                  for(let i = 0; i < this.organization.sno_array.length; i++){
                    if(this.organization.sno_array[i]['nds'] && this.organization.sno_array[i]['nds']['id']){
                      this.organization.sno_array[i]['nds_id'] = this.organization.sno_array[i]['nds']['id'];
                    }
                  }
                }

                      if(this.organization.leader_details){
                              if(this.organization.leader_details.employee_id && this.organization.leader_details.employee_id.id){
                                this.organization.leader_details.employee_id = this.organization.leader_details.employee_id.id
                              }
                              if(this.organization.leader_details.position_id && this.organization.leader_details.position_id.id){
                                this.organization.leader_details.position_id = this.organization.leader_details.position_id.id
                              }
                            }

                            if(this.organization.accountant_details){
                              if(this.organization.accountant_details.employee_id && this.organization.accountant_details.employee_id.id){
                                this.organization.accountant_details.employee_id = this.organization.accountant_details.employee_id.id
                              }
                              if(this.organization.accountant_details.position_id && this.organization.accountant_details.position_id.id){
                                this.organization.accountant_details.position_id = this.organization.accountant_details.position_id.id
                              }
                            }

                            if(this.organization.cashier_details){
                              if(this.organization.cashier_details.employee_id && this.organization.cashier_details.employee_id.id){
                                this.organization.cashier_details.employee_id = this.organization.leader_details.employee_id.id
                              }
                              if(this.organization.cashier_details.position_id && this.organization.cashier_details.position_id.id){
                                this.organization.cashier_details.position_id = this.organization.cashier_details.position_id.id
                              }
                            }
                    
                            if(this.organization.bank_account && this.organization.bank_account.id){
                              this.organization.bank_account_id = this.organization.bank_account.id
                            }

                            if(this.organization.org_type && this.organization.org_type === 'ФизЛицо'){
                              this.organization.org_type_value = 1;
                            } else {
                              this.organization.org_type_value = 0;
                            }

                            
        }
      })
    }

     this.$store.dispatch(billActionTypes.getListBill,{
              bank_acc: true
      }).then((response2) => {
        if (response2.success) {
            this.bank_account_list = response2.list
        }
      })

      this.$store.dispatch(lessonActionTypes.getPositionList, {}).then((resp) => {
          this.position_list = resp.position
        });

      this.$store.dispatch(lessonActionTypes.getSpecialistList, {}).then((resp) => {
        this.specialist_list = resp.specialist
      });

      this.$store.dispatch(organizationActionTypes.organizationList, {full:true}).then((resp) => {
        this.org_list = resp.organization
      });
    
  },
  methods: {
    setNomenOrg(item){
      if(this.selectedLine && this.selectedLine.id === item.id){
          this.selectedLine = null
        } else {
          this.selectedLine = item
        }
    },
    deleteBank(item){
      let status = item.deletion ? false : true
      this.$store.dispatch(organizationActionTypes.organizationCreate,{bank_id:item.id,remove:true,remove_type:status}
      ).then((response) => {
        if (response.success) {
          if(response.organization && response.organization.object_id){

            this.selectedLine = null

            this.bank_account_list = []
                this.new_bank = {
                  org_id:null,
                  number:null,
                  bik:null,
                  currency:null,
                  name:null
                  }

                this.$store.dispatch(billActionTypes.getListBill,{
                    bank_acc: true
                  }).then((response2) => {
                    if (response2.success) {
                        this.bank_account_list = response2.list
                    }
                  })
          }
        }
      })
    },
    updateBank(){
      console.log(this.new_bank)

      // this.new_bank.bank_id = "7739f134-5ce7-11ed-8122-6cae8b562436"
      this.new_bank.bankaccount_id = this.new_bank.id

      this.$store.dispatch(organizationActionTypes.organizationCreate,
        {bank:this.new_bank}
      ).then((response) => {
        if (response.success) {

          this.selectedLine = null

          this.bank_account_list = []
          this.new_bank = {
            org_id:null,
            number:null,
            bik:null,
            currency:null,
            name:null
            }

          this.$store.dispatch(billActionTypes.getListBill,{
              bank_acc: true
            }).then((response2) => {
              if (response2.success) {
                  this.bank_account_list = response2.list
              }
            })

            this.dialogBill = false
        }
      })
    },
    saveBank(){
      console.log(this.new_bank)

      //this.new_bank.bank_id = "7739f134-5ce7-11ed-8122-6cae8b562436"

      this.$store.dispatch(organizationActionTypes.organizationCreate,
        {bank:this.new_bank}
      ).then((response) => {
        if (response.success) {

          this.bank_account_list = []

          this.$store.dispatch(billActionTypes.getListBill,{
              bank_acc: true
            }).then((response2) => {
              if (response2.success) {
                  this.bank_account_list = response2.list
              }
            })

            this.dialogBill = false
        }
      })
    },
    // Кастомная фильтрация по названию и категории
    customFilter(item, queryText) {
      return item.name.toLowerCase().includes(queryText.toLowerCase());
    },
    addService(){
      let newObj = {
            date:null,
            sno:null,
            tax_subject:null,
            tax_group_id:null,
            nds_id:null,
            idd:Date.now()
          }
      this.organization.sno_array.push(newObj)
    },
    removeService(item_id){
   
      if(this.organization.sno_array.length > 1){
        this.organization.sno_array.splice(this.organization.sno_array.findIndex(n => n.id === item_id),1);
      }

    },
    addContact(){
      let obj = this.contact_def
      obj.type = 'Телефон'
      obj.type_name = 'Телефон'
      //obj.link = 'phonenumber'
      this.organization.contact_array.push(obj)
    },
    saveOrganization(org_id){
      console.log(this.organization)
      console.log(org_id)
      if(this.organization_id){
        this.organization.org_id = this.organization_id
      }

      if(this.organization.sno_array && this.organization.sno_array.length > 0) {
        for(let i = 0; i < this.organization.sno_array.length; i++){
          if(this.organization.sno_array[i]['nds'] && this.organization.sno_array[i]['nds']['id']){
            this.organization.sno_array[i]['nds_id'] = this.organization.sno_array[i]['nds']['id'];
          }
        }
      }

      if(this.organization.leader_details){
        if(this.organization.leader_details.employee_id && this.organization.leader_details.employee_id.id){
          this.organization.leader_details.employee_id = this.organization.leader_details.employee_id.id
        }
        if(this.organization.leader_details.position_id && this.organization.leader_details.position_id.id){
          this.organization.leader_details.position_id = this.organization.leader_details.position_id.id
        }
      }

      if(this.organization.accountant_details){
        if(this.organization.accountant_details.employee_id && this.organization.accountant_details.employee_id.id){
          this.organization.accountant_details.employee_id = this.organization.leader_details.employee_id.id
        }
        if(this.organization.accountant_details.position_id && this.organization.accountant_details.position_id.id){
          this.organization.accountant_details.position_id = this.organization.accountant_details.position_id.id
        }
      }

      if(this.organization.cashier_details){
        if(this.organization.cashier_details.employee_id && this.organization.cashier_details.employee_id.id){
          this.organization.cashier_details.employee_id = this.organization.leader_details.employee_id.id
        }
        if(this.organization.cashier_details.position_id && this.organization.cashier_details.position_id.id){
          this.organization.cashier_details.position_id = this.organization.cashier_details.position_id.id
        }
      }

      this.$store.dispatch(organizationActionTypes.organizationCreate,
        this.organization
      ).then((response) => {
        if (response.success) {

          if(response.organization && response.organization.id){
            this.$router.push({
              name: 'AdminNormatives',
              params: {
                new_organization_id: response.organization.id
              }
            });
          }
      
        }
      })
    },
    deleteOrganization(status){
      this.$store.dispatch(organizationActionTypes.organizationCreate,{org_id:this.organization_id,remove:true,remove_type:status}
      ).then((response) => {
        if (response.success) {
          if(response.organization && response.organization.object_id){
            this.$router.push({
              name: 'AdminNormatives',
              params: {
                new_organization_id: response.organization.object_id
              }
            });
          }
        }
      })
    }
  }
      
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px !important;
}
.card-title {
  font-family: 'Circe', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.vd-activator .custom__datepicker44 {

  /* margin: 0px 0px 0px -12px !important; */
  border:1px solid #e0e0e0 !important;
  width: 100%;
  display: flex;
}

.active-row td {
  background-color: #bbdefb !important; /* светло-голубой */
}
#table-1 tbody tr.active-row {
  background-color: #bbdefb !important;
}


</style>